import type { SVGProps } from 'react';
const SvgHeight = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="0.75em"
    height="0.75em"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#height_svg__a)">
      <path
        fill="currentColor"
        d="M13 6.99h3L12 3 8 6.99h3v10.02H8L12 21l4-3.99h-3V6.99Z"
      />
    </g>
    <defs>
      <clipPath id="height_svg__a">
        <path fill="currentColor" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgHeight;
